import EventBus from "@/EventBus";
import {App} from "@capacitor/app";
import { Capacitor } from '@capacitor/core';

class ZebraHardwareScanner {

    stack = [];

    isReady = false;
    constructor() {
	if (Capacitor.getPlatform() === 'web') {
            return;
	}
        this.setupScanner();
    }
    ready() {
        if (this.isReady) {
            EventBus().emitter.emit('zebra.ready');
        }
        return this.isReady;
    }
    setupScanner() {
        const result = window['plugins'].intentShim.registerBroadcastReceiver({
            filterActions: [
                'com.zebra.ionicdemo.ACTION',
                'com.symbol.datawedge.api.RESULT_ACTION'
            ],
            filterCategories: [
                'android.intent.category.DEFAULT'
            ]
        }, intent => {
            const type = Object.keys(intent.extras)[0];
            const event = type.replace('com.symbol.datawedge.api.', '');
            EventBus().emitter.emit(`zebra.response.${event}`, {
                raw: intent,
                response: intent.extras[type]
            });
            EventBus().emitter.emit('zebra.response', {
                raw: intent,
                response: intent.extras[type]
            });
        });
        setTimeout(() => {
            console.log("sending a ping to the scanner see what happens...");
            this.ping().then(() => {
                console.log("setting this ready to true");
                this.isReady = true;
                this.ready();
            });
        }, 1000);
    }
    sendCommand(command, value = '') {
        const extras = {};
        extras[command] = value;
        const payload = {
            action: 'com.symbol.datawedge.api.ACTION',
            extras: {...extras, ...{
                'SEND_RESULT': 'true',
                'COMMAND_IDENTIFIER': 'acdef'
            }}
        };
        window['plugins'].intentShim.sendBroadcast(
            payload, () => {
                //
            },() => {
                //
            }
        );
        console.log("Sending %o", payload);
    }

    /**
     * Seriously, this is some of the most voodoo BS I've ever seen:
     * https://stackoverflow.com/a/29933215
     *
     * We send the comment then we return a promise which resolves
     * once we get a response from the zebra hardware.
     *
     * We use 'once' to make sure that if we call this multiple times,
     * we don't end up repeatedly calling it.
     *
     * @returns {Promise<unknown>}
     */
    ping() {
        this.sendCommand('com.symbol.datawedge.api.GET_VERSION_INFO');
        return new Promise(resolve => {
            EventBus().emitter.once(
                'zebra.response.RESULT_GET_VERSION_INFO',
                resolve
            );
        });
    }
}
export default ZebraHardwareScanner;
